module.exports = __webpack_public_path__ + "media/images/logo-697f46d5cb7276e77305e76f8879e7bc.png";